import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { PropertyService } from "../shared/property.service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { DataShareService } from "../shared/data-share.service";
import { NgxSpinnerService } from "ngx-spinner";
import _ from "lodash";
import { EncrDecrService } from "../shared/EncrDecrService.service";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";
import { Loader, LoaderOptions } from "google-maps";
import { Subscription } from "rxjs";
import _trim from "lodash/trim";
@Component({
  selector: "app-home-properties-list",
  templateUrl: "./home-properties-list.component.html",
  styleUrls: ["./home-properties-list.component.css"],
})
export class HomePropertiesListComponent implements OnInit, OnDestroy {
  // infinite scroll settings
  public _get = _.get;
  public _uniqBy = _.uniqBy;
  public propertiesList = [];
  public properties = [];
  public currentPage = 1;
  public throttle = 300;
  public scrollDistance = 4;
  public scrollUpDistance = 2;
  public search_obj = {};
  public hasNoPropertyRecords = false;
  public isDisplayMap = false;
  public user = null;
  public imageUrl = environment.imageUrl + "uploads/thumb/";

  public lat: number = -33.8781954;
  public long: number = 151.2031137;
  // carousel settings
  public customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    autoplay: false,
    autoWidth: true,
    navSpeed: 700,
    navText: ["&#8249;", "&#8250;"],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      940: {
        items: 4,
      },
    },
    nav: true,
  };
  @ViewChild("mapView") mapElement: ElementRef;
  public options: LoaderOptions = {
    /* todo */
  };
  public loader = new Loader(
    "AIzaSyB_L4pPNYwWjRXJM_lFvRfKWCNK2L3oNDs",
    this.options
  );

  private subscriptions: Subscription = new Subscription();

  public userSettings1 = {};
  constructor(
    private route: ActivatedRoute,
    private propertyService: PropertyService,
    private dataShare: DataShareService,
    private spinner: NgxSpinnerService,
    private EncrDecr: EncrDecrService,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.spinner.show("outer");
    this.propertiesList = [];
    this.properties = this.route.snapshot.data["propertyList"];
    this.search_obj = {
      listingType: "",
      locations: [
        {
          region: "Australia",
          area: "Louisa Road",
          includeSurroundingSuburbs: false,
          postCode: "2041",
          state: "NSW",
          suburb: "Birchgrove",
          lat: -33.8480941,
          lng: 151.181906,
        },
      ],
      page: 1,
      pageSize: 10,
      type: "PropertyListing",
      limit: 12,
    };
  }

  ngOnInit() {
    this.subscriptions.add(
      this.dataShare.loginUser.subscribe((data) => {
        if (data) {
          this.user = localStorage.getItem("user")
            ? this.EncrDecr.getEncrypt(localStorage.getItem("user"))
            : null;
          console.log("this.user :: 1 => ", this.user);
        } else {
          this.user = localStorage.getItem("user")
            ? this.EncrDecr.getEncrypt(localStorage.getItem("user"))
            : null;
          console.log("this.user :: 1 => ", this.user);
        }
        if (this.user && this.user.data && this.user.data._id) {      
          this.getClaimedProperties();
        }
      })
    );
    this.fetchProperties(this.search_obj);
    this.userSettings1 = {
      inputPlaceholderText: "Enter Address here..",
      geoCountryRestriction: "au",
      inputString: "",
      showSearchButton: false,
      noOfRecentSearchSave: 3,
      showCurrentLocation: false,
    };
  }

  getClaimedProperties() {
    const data = {
      request_by_role: '5a1d295034240d4077dff208', // role_id for 'Property Owner'
      user_id: this.user.data._id,
    };
    this.propertyService.getClaimedPropertyList(data).subscribe((res) => {
      if (res && res["data"]) {
        this.propertiesList = res["data"].concat(this.propertiesList);
      }
    });
  }

  createPropertyAraay(properties) {
    let list = [];
    // properties.forEach((p) => {
    //   if (p.hasOwnProperty("listing")) {
    //     list.push(p.listing);
    //   }
    //   if (p.hasOwnProperty("listings")) {
    //     if (p.listings.length > 0) {
    //       p.listings.forEach((ele) => {
    //         list.push(ele);
    //       });
    //     }
    //   }
    // });
    if (properties && properties.data) {
      for (let index = 0; index < properties.data.length; index++) {
        const propertyItem = properties.data[index];
        // let propertyImg = []
        // propertyItem.image.forEach(item => {
        //   propertyImg.push({...item, path: `${this.imageUrl}${item.path}`})
        // })
        // propertyItem.image = propertyImg
        // console.info('--------------------------')
        // console.info('propertyItem =>',propertyItem)
        // console.info('--------------------------')
        list.push(propertyItem);
      }
    }
    if (list.length === 0) {
      this.hasNoPropertyRecords = true;
    } else {
      this.hasNoPropertyRecords = false;
    }
    this.addItems(list);
    this.spinner.hide("outer");
  }

  addItems(list) {
    const cnt = list.length;
    for (let i = 0; i < cnt; i++) {
      this.propertiesList["push"](list[i]);
    }
    this.propertiesList = this._uniqBy(this.propertiesList, (obj) =>
      [this._get(obj, "_id", "")].join()
    );
    this.spinner.hide("outer");
  }

  onScrollDown() {
    this.currentPage += 1;
    this.search_obj["page"] = this.currentPage;
    this.search_obj["limit"] = 12;
    this.propertyService
      .getProperties(this.search_obj)
      .toPromise()
      .then(async (res) => {
        this.hasNoPropertyRecords = false;
        await this.createPropertyAraay(res);
      });
  }

  followProperty(propertyId, propertyDetails) {
    let userId = this.user.data._id;
    let findFollow = this.isFollowing(propertyDetails.favDetail)
      ? this.isFollowing(propertyDetails.favDetail)
      : null;
    let status = 1;
    if (findFollow) {
      if (findFollow.fav_status === 1) {
        status = 2;
      } else {
        status = 1;
      }
    } else {
      status = 1;
    }

    this.propertyService
      .addToFavouritesProperty(userId, status, propertyId)
      .toPromise()
      .then(async (res: any) => {
        if (res.code == 200) {
          if (status === 1) {
            this.toastr.success(
              "Successfully marked property as favourites",
              "Success!",
              {
                timeOut: 3000,
              }
            );
            this.fetchProperties(this.search_obj);
          } else if (status === 2) {
            this.toastr.success(
              "Successfully unmarked property as favourites",
              "Success!",
              {
                timeOut: 3000,
              }
            );
          }
        }
        this.spinner.show("outer");
      });
  }

  isFollowing(favDetails = []) {
    if (this.user) {
      let findFav = _.filter(
        favDetails,
        (fav) => fav.fav_by === this.user.data._id
      );
      if (findFav.length > 0) {
        return findFav[0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  openPropertyDetailPage(property: any): void {
    this.router.navigate([`/property/${property._id}`]);
  }

  autoCompleteCallback1(selectedData: any) {
    if (!selectedData || !selectedData.data) {
      return;
    }

    var locationObj = {
      region: "",
      area: "",
      includeSurroundingSuburbs: false,
      postCode: "",
      state: "",
      suburb: "",
      lat:
        selectedData.data.geometry && selectedData.data.geometry.location
          ? selectedData.data.geometry.location.lat
          : null,
      lng:
        selectedData.data.geometry && selectedData.data.geometry.location
          ? selectedData.data.geometry.location.lng
          : null,
    };

    var unitNumber = "";
    var streetNumberStr = "";
    var routeNameStr = "";
    var suburbFlag = 0;
    var stateFlag = 0;
    var postCodeFlag = 0;
    var streetNumberFlag = 0;
    var routeFlag = 0;

    if (
      selectedData.data.address_components &&
      Array.isArray(selectedData.data.address_components) &&
      selectedData.data.address_components.length > 0
    ) {
      selectedData.data.address_components.forEach(function (component: any) {
        var addressType = component.types;
        if (addressType.indexOf("street_number") >= 0) {
          streetNumberStr = component.long_name;
          streetNumberFlag = 1;
        }
        if (addressType.indexOf("route") >= 0) {
          routeNameStr = component.long_name;
          routeFlag = 1;
        }
        if (addressType.indexOf("postal_code") >= 0) {
          locationObj.postCode = component.long_name;
          postCodeFlag = 1;
        }
        if (addressType.indexOf("administrative_area_level_1") >= 0) {
          locationObj.state = component.short_name;
          stateFlag = 1;
        }
        if (addressType.indexOf("locality") >= 0) {
          locationObj.suburb = component.long_name;
          suburbFlag = 1;
        }
        if (addressType.indexOf("country") >= 0) {
          locationObj.region = component.long_name;
        }
      });
    }

    locationObj.area = selectedData.data.name || "";
    locationObj.suburb = suburbFlag ? locationObj.suburb : "";
    locationObj.postCode = postCodeFlag ? locationObj.postCode : "";
    locationObj.state = stateFlag ? locationObj.state : "";
    this.search_obj["locations"] = [locationObj];
    const searchbtn = document.getElementById("btnPropertysearch");
    searchbtn.focus();
  }

  search() {
    if (this.search_obj) {
      this.fetchProperties(this.search_obj);
    } else {
      this.toastr.info("Please choose valid input!", "");
    }
  }

  async fetchProperties(searchParams: any) {
    this.spinner.show("outer");
    this.propertiesList = [];

    try {
      const res: any = await this.propertyService
        .getProperties(searchParams)
        .toPromise();

      this.hasNoPropertyRecords = false;
      await this.createPropertyAraay(res);
    } catch (error) {
      console.error("API call failed:", error);
      this.hasNoPropertyRecords = true;
    }

    this.spinner.hide("outer");
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.search_obj = {};
  }
}
